import { View } from 'react-native';

import { Text, tokens } from '@fhs/ui';

interface SingleServiceModeDisplayProps {
  selectedServiceModeLabel: string;
  selectedServiceModeDescription: string;
}

function SingleServiceModeDisplay({
  selectedServiceModeLabel,
  selectedServiceModeDescription,
}: SingleServiceModeDisplayProps) {
  return (
    <View
      style={{
        width: '100%',
        marginVertical: 20,
        paddingVertical: 16,
        paddingHorizontal: 16,
        borderWidth: 1,
        borderColor: tokens.colors.$black10,
        borderRadius: 8,
        backgroundColor: tokens.colors.$white,
      }}
    >
      <View style={{ gap: 2 }}>
        <Text.Ui size="sm">Pickup Mode</Text.Ui>
        <Text.Ui size="md" weight="bold">
          {selectedServiceModeLabel}
        </Text.Ui>
        <Text.Ui size="sm">{selectedServiceModeDescription}</Text.Ui>
      </View>
    </View>
  );
}

export default SingleServiceModeDisplay;
